module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      open: _vm.showmodal
    }
  }, [_c('div', {
    staticClass: "modal__backdrop",
    on: {
      "click": _vm.hideModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__dialog"
  }, [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', [_vm._v("\n\t\t\tΗ τέχνη της χαρακτικής ξεκινά από το σχέδιο, όπως και η ζωγραφική. Με τον όρο χαρακτική εννοούμε όλες τις διαδικασίες που ακολουθεί ο χαράκτης για να μεταφέρει μια σύνθεση που έχει προσχεδιάσει, σε μία επιφάνεια ξύλου, χαλκού, πέτρας ή άλλου υλικού (χαρακτική πλάκα) και έπειτα να την τυπώσει, συνήθως, σε χαρτί. ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tΗ τέχνη της χαρακτικής και οι διάφορες τεχνικές της μας εισήγαγαν στην έννοια του πολλαπλού, αφού προσέφεραν τη δυνατότητα αναπαραγωγής ενός έργου σε πολλά αντίτυπα, τα χαρακτικά. Ωστόσο ένα χαρακτικό -ιδίως σήμερα- μπορεί να είναι μοναδικό (το λεγόμενο μονότυπο/monoprint). Ο χαράκτης αποφασίζει για τον αριθμό αντιτύπων που θα φτιάξει και αριθμεί καθένα από αυτά.")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tΤα πρώτα χαρακτικά ήταν ξυλογραφίες που εμφανίστηκαν στην Κίνα τον 9ο αιώνα, ενώ στην Ευρώπη διαδόθηκαν τον 14ο αιώνα. Ακολουθούν οι χαλκογραφίες περί τα μέσα του 15ου αιώνα. Στην Ελλάδα, η πορεία ήταν αντίστροφη. Εδώ, τα πρώτα χαρακτικά που τυπώθηκαν ήταν χαλκογραφίες, ενώ οι ξυλογραφίες ήρθαν αργότερα. Η χαρακτική τέχνη θα καθιερωθεί στην Ελλάδα στις αρχές της δεκαετίας του 1930 με την επανέναρξη της διδασκαλίας της χαρακτικής από τον Γιάννη Κεφαλληνό στην Ανωτάτη Σχολή Καλών Τεχνών, έπειτα από περίπου 15 έτη διακοπής. ")]), _vm._v(" "), _c('p', [_vm._v(" Με την εξέλιξη της τεχνολογίας η τέχνη της χαρακτικής αποκτά ολοένα και δυναμικότερο χαρακτήρα, με τους χαράκτες να πειραματίζονται σε νέα υλικά και να συνδυάζουν διάφορες τεχνικές, διευρύνοντας ακόμα περισσότερο το πεδίο έκφρασής της. \n\t\t  ")]), _vm._v(" "), _c('a', {
    staticClass: "close-modal",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/close.svg"),
      "alt": ""
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67567d5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 571
// module chunks = 1